'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AutoCollapser = require('components/AutoCollapser/AutoCollapser');

var _AutoCollapser2 = _interopRequireDefault(_AutoCollapser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./QuickSendRecipients.scss');

var QuickSendRecipients = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(QuickSendRecipients, _PureComponent);

  function QuickSendRecipients() {
    (0, _classCallCheck3.default)(this, QuickSendRecipients);
    return (0, _possibleConstructorReturn3.default)(this, (QuickSendRecipients.__proto__ || (0, _getPrototypeOf2.default)(QuickSendRecipients)).apply(this, arguments));
  }

  (0, _createClass3.default)(QuickSendRecipients, [{
    key: 'render',
    value: function render() {
      var recipients = this.props.recipients;

      var recipientsList = recipients.map(function (recipient) {
        return recipient.fullName;
      }).join(', ');

      return _react2.default.createElement(
        _AutoCollapser2.default,
        { className: styles.list },
        recipientsList
      );
    }
  }]);
  return QuickSendRecipients;
}(_react.PureComponent), _class.propTypes = {
  recipients: _propTypes2.default.array
}, _class.defaultProps = {
  recipients: []
}, _temp);
exports.default = QuickSendRecipients;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/QuickSend/QuickSendRecipients.js
// module id = 2076
// module chunks = 1